import { useCallback } from 'react';
import { useCookie } from 'react-use';

// Default cookie options. Expires in 1 day, strict same-site rules (don't send cross origin).
const COOKIE_OPTIONS = { expires: 1, sameSite: 'strict' } as const;

/**
 * Dis-loyalty has a Membership Services team that use the booking engine to make bookings on behalf of users. The
 * backend uses headers to identify whether the user is a Membership Services user or not and serves a different
 * experience when it comes to bundled membership rates. This is driven by a cookie in the users' browser, set by
 * visiting a specific link.
 */
export function useMembershipServicesModeState() {
  const [cookie, setCookie] = useCookie('membership-services-mode');

  const isEnabled = cookie === 'true';
  const setMembershipServicesMode = useCallback(
    (enabled: boolean) => {
      setCookie(enabled ? 'true' : 'false', COOKIE_OPTIONS);
    },
    [setCookie]
  );

  return [isEnabled, setMembershipServicesMode] as const;
}
